import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonical, ogImage }) => {
  // Titre par défaut et description par défaut si non fournis
  const defaultTitle = 'Aiko | Créations digitales qui transforment votre entreprise';
  const defaultDescription = 'Nous concevons des sites web et des expériences digitales qui captent l\'attention, engagent vos utilisateurs et convertissent vos visiteurs en clients fidèles.';
  
  // Valeurs finales
  const siteTitle = title ? `${title} | Aiko` : defaultTitle;
  const siteDescription = description || defaultDescription;
  const siteUrl = 'https://aiko.fr';
  const siteImage = ogImage || `${siteUrl}/og-image.jpg`;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      {/* Balises de base */}
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Balises Open Graph pour les réseaux sociaux */}
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={siteImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Aiko" />
      
      {/* Balises Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={siteImage} />
      
      {/* Autres balises meta importantes */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta charSet="utf-8" />
      <html lang="fr" />
    </Helmet>
  );
};

export default SEO;
